import { render, staticRenderFns } from "./UploadCsvModal.vue?vue&type=template&id=85f620e0&scoped=true&"
import script from "./UploadCsvModal.vue?vue&type=script&lang=js&"
export * from "./UploadCsvModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadCsvModal.vue?vue&type=style&index=0&id=85f620e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f620e0",
  null
  
)

export default component.exports